export default __webpack_public_path__ + "static/media/evry-logo.c606a260.svg";